import { render, staticRenderFns } from "./alert.component.vue?vue&type=template&id=223ea0da"
import script from "./alert.component.vue?vue&type=script&lang=ts"
export * from "./alert.component.vue?vue&type=script&lang=ts"
import style0 from "./alert.component.vue?vue&type=style&index=0&id=223ea0da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports